import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetListeningSessionV1Response } from './get-listening-session-v1-response';
import { getListeningSessionV1ResponseSchema } from './get-listening-session-v1-response';

export async function getListeningSessionV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetListeningSessionV1Response>> {
  return getRequest<IGetListeningSessionV1Response>({
    path: '/listening/session/v1',
    schema: getListeningSessionV1ResponseSchema,
    options,
  });
}
